import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import ReminderNotificationData from "./ReminderNotificationData";
import {NotificationBaseApiDto, ReminderNotificationDataApiDto} from "../../../api/model/rest";
import {getUser} from "../../../store/view/user";

/**
 * Reminder notification class.
 */
export default class ReminderNotification extends NotificationBase {
	/**
	 * @param {string} id Notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read Flag if note is marked as read.
	 * @param {"NOTE_REMINDER"} type Note type, in this case always 'NOTE_REMINDER'.
	 * @param {ReminderNotificationData} data Note notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: ReminderNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): ReminderNotification {
		return new ReminderNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			ReminderNotificationData.fromJson(json.data as ReminderNotificationDataApiDto));
	}

	/**
	 * Display user Full name.
	 * @returns {string}
	 */
	displayCreatorName() {
		return getUser(this.data.creator.id).map(u => u.getDisplayName()).getOrElse(this.data.creator.id);
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new ReminderNotification(id, dateTime, read, type, data);
	}
}